import { createApp } from 'vue';
import { piniaInstance } from './stores/global';

import App from './App.vue';
import router from './router/index';

import VueDOMPurifyHTML from 'vue-dompurify-html';

import './assets/css/base/unoDropZone.css';
import './assets/css/base/component.css';
import './assets/css/base/digitalDeposit.css';
import './assets/css/base/fancyBox.css';

import './assets/css/OCA.css';

const app = createApp(App);
app.use(piniaInstance);
app.use(router);
app.use(VueDOMPurifyHTML);
app.mount('#app');
